<div class="form-group">
    <label *ngIf="title">{{title}} {{control | controlRequiredText}}</label>

    <div [class.disabled]="control.disabled" [class.dropdown-purple-20]="style === 'purple'"
        class="dropdown dropdown-filter dropdown-input-filter dropdown-input-tag-collapse dropdown-one-line-txt-btn one-indent-level dropdown-self-tag"
        [id]="id + '-dp'">
        <button [class.data-required]="control.touched && control.invalid"
            class="btn dropdown-toggle dropdown-toggle-no-arrow" type="button" [id]="id" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            {{control.value || placeholder}}
        </button>
        <div class="dropdown-menu dropdown-menu-filter" aria-labelledby="dropdownBtnStatus">

            <div class="mgn-bottom-10" *ngIf="enabledFilter">
                <label [for]="id + '-search'" class="accesibleHidden">{{placeholderSearch}}</label>
                <input type="text" class="form-control filter-input" [id]="id + '-search'"
                    [placeholder]="placeholderSearch" />
            </div>

            <div class="collapse-fieldset-group">

                <ng-container *ngFor="let e of dataSelectGroup; let i = index">

                    <div [class.display-none]="e?.enabled === false" class="collapse-fieldset">

                        <div class="fieldset-header group-heading">
                            <a data-toggle="collapse" [attr.href]="'#collapse' + i">
                                <i class="pj-ico pj-ico-flecha-colapsable"></i>{{e.parent}}
                            </a>
                        </div>
                        <div [id]="'collapse' + i" class="fieldset-body show">
                            <div class="checkbox-group" *ngFor="let s of e.items" [id]="id + '-group-' + i">
                                <div class="wrap-checkbox">
                                    <label class="radio-label" [for]="id + s.id">
                                        <input (click)="onUncheckRadio(s.child)" type="radio" [id]="id + s.id"
                                            [name]="'radio-group-' + id" [value]="s.child" [formControl]="control" />
                                        <span class="radiomark"></span>
                                        {{s.child}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                </ng-container>
            </div>

            <div class="no-result-ctn d-none">
                No se encontraron resultados
            </div>

        </div>

    </div>

    <div-validation-message [control]="control" [messageRequired]="messageRequired"></div-validation-message>

    <small *ngIf="messageFooter" class="form-text text-muted">{{messageFooter}}
        <a class="btn-link" *ngIf="messageFooterAction" (click)="onClickActionFooter($event)" role="button"
            [title]="messageFooterAction">{{messageFooterAction}}</a>
    </small>
</div>